import { useEffect } from "react";

export function useElementHeight(ref: React.RefObject<HTMLElement | null>, onHeight: (h: number) => void) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      if (entry) onHeight(Math.round(entry.contentRect.height));
    });
    ro.observe(el);
    onHeight(Math.round(el.getBoundingClientRect().height / 1));
    return () => ro.disconnect();
  }, [ref, onHeight]);
}
